import { Auth0Client } from '@auth0/auth0-spa-js';

export const REACT_APP_ENVIRON = process.env.REACT_APP_ENVIRON
  ? process.env.REACT_APP_ENVIRON
  : 'staging';

let auth0Domain;
let auth0ClientId;
let graphqlEndpoint;
let cognitoIDPool;
if (REACT_APP_ENVIRON === 'production') {
  auth0Domain = 'missionportal.us.auth0.com';
  auth0ClientId = 'kVsC4ZyVitGajGbFlrpMH23y3nU0l3kx';
  graphqlEndpoint = 'https://api.missionportal.com/graphql';
  cognitoIDPool = 'us-east-1:da1de39a-9658-4835-bddc-c1a64eae1c3c';
} else if (REACT_APP_ENVIRON === 'staging') {
  auth0Domain = 'missionportal-staging.us.auth0.com';
  auth0ClientId = 'mYy0BcL7CIpM08AqJPzCB98Lpj6MAHNf';
  graphqlEndpoint = 'https://oesxty5uovcudkobxyhvgzi4su.appsync-api.us-east-1.amazonaws.com/graphql';
  cognitoIDPool = 'us-east-1:3728ebbd-1844-4c49-afca-826b228715e1';
} else {
  auth0Domain = 'missionportal-dev.us.auth0.com';
  auth0ClientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
  graphqlEndpoint = process.env.REACT_APP_GRAPHQL_ENDPOINT;
  cognitoIDPool = process.env.REACT_APP_COGNITO_ID_POOL;
}

// MissionPortal-DB audience has offline_access enabled in Auth0.
// This allows us to use refresh tokens which are automatically rotated by Auth0.
// Refresh token rotation reduces security risks from compromised tokens and
// mitigates negative effects of browser privacy features.
export const authconfig = {
  domain: auth0Domain,
  clientId: auth0ClientId,
  audience: 'MissionPortal-DB',
};

// AWS Amplify v6 configuration:
// - API.GraphQL.defaultAuthMode: 'openidConnect' - Uses Auth0 tokens for AppSync
// - Auth.Cognito.identityPoolId: Legacy config, kept for backward compatibility
//   (not actively used with Auth0 OIDC flow, but required by Amplify)
export const awsconfig = {
  API: {
    GraphQL: {
      endpoint: graphqlEndpoint,
      region: 'us-east-1',
      defaultAuthMode: 'openidConnect',
    },
  },
  Auth: {
    Cognito: {
      identityPoolId: cognitoIDPool,
      region: 'us-east-1',
    },
  },
};

// Shared Auth0 client configuration
const getAuth0Client = () => new Auth0Client({
  domain: auth0Domain,
  clientId: auth0ClientId,
  authorizationParams: {
    redirect_uri: `${window.location.origin}/callback`,
    audience: 'MissionPortal-DB',
    scope: 'openid email profile read:current_user update:current_user_metadata offline_access',
  },
  cacheLocation: 'localstorage',
  useRefreshTokens: true,
});

/**
 * Get Auth0 access token for API calls
 * @returns {Promise<string|null>} The auth token or null if not authenticated
 */
export const getAuthToken = async () => {
  try {
    const auth0 = getAuth0Client();
    return await auth0.getTokenSilently({ cacheMode: 'on' });
  } catch (error) {
    return null;
  }
};

/**
 * Get authorization headers for WebSocket/API requests
 * @returns {Promise<Object>} Headers object with Authorization token
 */
export const getAuthHeaders = async () => {
  const token = await getAuthToken();
  return token ? { Authorization: token } : {};
};

const dromoFrontendLicense = {
  production: '9cce1b92-9df8-4b6d-904b-40f231513101',
  staging: '171ccc59-1c10-434d-9a39-e4ea3bba0445',
};

export const dromoFrontendLic = REACT_APP_ENVIRON === 'production'
  ? dromoFrontendLicense.production
  : dromoFrontendLicense.staging;

// expires on Jun 8, 2025
export const MuiPremiumLic = '6c98c183b74deab3e63c4cad40c0ff75Tz0xMTQzNTgsRT0xNzgxMTM1OTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y';
